export const kTeams = Object.freeze(['Lightning', 'Thunder', 'Hailstorm']);
export const kSeats = ['A1', 'A2', 'A3', 'B1', 'B2', 'B3', 'C1', 'C2', 'C3', 'D1', 'D2', 'D3'];
export const kRooms = ['Engineering Room', 'Field', 'Capstone Area'];
export const kRoomPrefixes = {
    'Engineering Room': 'E',
    Field: 'F',
    'Capstone Area': 'L'
};
